// Proyectos, sus fases y sus horas, con el avance de cada uno (D96). Lo usan Proyectos, el Resumen de Ventas y la
// campana (por eso vive aparte de la pantalla: la campana esta en todas las pantallas).
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { horasDeProyectos } from '../api/proyectos';
import { type Avance, avanceDe } from '../lib/proyectos';
import { useFases, useProyectos } from './HorasForm';

export function useAvances() {
  const pr = useProyectos();
  const fs = useFases();
  const ids = useMemo(() => (pr.data ?? []).map((p) => p.id).sort(), [pr.data]);
  const hs = useQuery({ queryKey: ['horas', 'proyectos', ids.join(',')], queryFn: () => horasDeProyectos(ids), enabled: !!pr.data, staleTime: 60_000 });
  const avances = useMemo(() => {
    const m = new Map<string, Avance>();
    for (const p of pr.data ?? []) m.set(p.id, avanceDe(p, fs.data ?? [], hs.data ?? []));
    return m;
  }, [pr.data, fs.data, hs.data]);
  return { proyectos: pr.data ?? [], fases: fs.data ?? [], horas: hs.data ?? [], avances, cargando: pr.isLoading || fs.isLoading || hs.isLoading, error: pr.error ?? fs.error ?? hs.error, reintentar: () => void (pr.refetch(), fs.refetch(), hs.refetch()) };
}

